/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "fac",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        name: "flash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "feeX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "feeY",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "flashCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        name: "flashNotPayBackEnoughX",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        name: "flashNotPayBackEnoughY",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "pool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestFlash__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(fac, overrides) {
        return super.deploy(fac, overrides || {});
    }
    getDeployTransaction(fac, overrides) {
        return super.getDeployTransaction(fac, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestFlash__factory.bytecode = _bytecode;
TestFlash__factory.abi = _abi;
